export const MAX_WORD_LENGTH = 5;
export const MAX_CHALLENGES = 6;
export const ALERT_DELAY = 2000;
